import { useRecoilState } from "recoil";
import { authAtom, sitesAtom } from "state/recoil-root";
import instance from "helpers/instance";
import { totalRow } from "state/roles-permissions";

const useSiteActions = () => {
  const [auth] = useRecoilState(authAtom);
  const [sites, setSites] = useRecoilState(sitesAtom);
  const [totalRows, setTotalRows] = useRecoilState(totalRow);

  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };
  return {
    getAllSites,
    getSiteDetail,
    createSite,
    updateSite,
    updateSiteStatus,
  };

  function getAllSites(filter, page = 0, pageSize = 10) {
    const offset = page * pageSize;
    const params = {
      ...filter,
      offset,
      limit: pageSize,
    };
    return instance({
      url: "usermanagement/v1/sites",
      method: "GET",
      params,
      headers,
    })
      .then((res) => {
        if (res.status === 200) {
          setTotalRows((preState) => ({
            ...preState,
            sites: res.data.meta.total || 0,
          }));
          setSites(res.data.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getSiteDetail(siteID) {
    return instance({
      url: `usermanagement/v1/sites/${siteID}`,
      method: "GET",
      headers,
    });
  }

  function createSite(data) {
    return instance({
      url: "usermanagement/v1/sites",
      method: "POST",
      data,
      headers,
    });
  }

  function updateSite(data, siteID) {
    return instance({
      url: `usermanagement/v1/sites/${siteID}`,
      method: "PUT",
      headers,
      data,
    });
  }

  function updateSiteStatus(data, siteID) {
    return instance({
      url: `usermanagement/v1/sites/${siteID}/status`,
      method: "PUT",
      headers,
      data: {
        status: data,
      },
    });
  }
};
export { useSiteActions };
